import React from "react";
import { getObjectFromFirestore } from "../firebase/fireFuncs";
import { updatePlayerArrays } from "../firebase/playerFuncs";
import { getId } from "../misc/helperfuncs";
import collectionStore from "../stores/collectionStore";
import MainStore from "../stores/MainStore";
import useHandleBoxTypes from "./useHandleBoxTypes";

const useHandlePlayerArrays = () => {
  const { getPluralType } = useHandleBoxTypes();
  const { open, saved, general, updateArray, addGeneralObjects } =
    collectionStore();
  const { player } = MainStore();
  const colObj = {
    open,
    saved,
    general,
  };

  function getObject(collection, type, id) {
    const array = colObj[collection][getPluralType(type)];
    return array.find((o) => o.id == id);
  }

  function findObjectById(id, type, onFound, onFoundPayload) {
    const foundObjects = {
      open: getObject("open", type, id),
      saved: getObject("saved", type, id),
      general: getObject("general", type, id),
    };

    function onObjectsFound(fireGeneral) {
      if (fireGeneral) foundObjects.general = fireGeneral;
      onFound(foundObjects, onFoundPayload);
    }
    if (foundObjects.general == null) {
      getObjectFromFirestore(
        type,
        id,
        addGeneralObjects,
        getPluralType,
        onObjectsFound
      );
    } else onObjectsFound();
  }

  function getArray(collection, type) {
    const array = colObj[collection][getPluralType(type)];
    return array;
  }

  function addObject(collection, object) {
    console.log(
      "useHandlePlayerArrays | addObject - collection - ",
      collection,
      " | object - ",
      object
    );
    console.log(" colObj[collection] -", getPluralType(object.type));
    const array = colObj[collection][getPluralType(object.type)];
    const found = array.find((o) => o.id == object.id);
    if (!found) {
      array.push(object);
      updatePlayerArrays(
        player.uid,
        collection,
        getPluralType(object.type),
        array
      );
    }
  }

  function updateObject(collection, object) {
    console.log("bug1 | collection - ", collection, " | object - ", object);
    const array = colObj[collection][getPluralType(object.type)];
    const found = array.find((o) => o.id == object.id);
    if (found) {
      const index = array.indexOf(found);
      array[index] = object;
      updatePlayerArrays(
        player.uid,
        collection,
        getPluralType(object.type),
        array
      );
    }
  }

  function removeObject(object, collection) {
    const filteredArray = colObj[collection][getPluralType(object.type)].filter(
      (o) => o.id != object.id
    );
    updateArray(collection, getPluralType(object.type), filteredArray);
    updatePlayerArrays(
      player.uid,
      collection,
      getPluralType(object.type),
      filteredArray
    );
  }

  function makeHistoryObject() {
    return {
      historyId: getId(),
    };
  }

  return {
    updateObject,
    getObject,
    addObject,
    getArray,
    findObjectById,
    removeObject,
  };
};

export default useHandlePlayerArrays;
